import { createStore } from 'vuex';
import { Contract } from "@/models/Contract";
import ConfiguracioService from "@/services/ConfiguracioService";

interface ConfiguracioState {
    horaInicial: string | null;
    horaFinal: string | null;
}

const store = createStore({
    state: {
        isLoading: false,
        loadingCount: 0,
        locale: localStorage.getItem('locale') || window.navigator.language.slice(0, 2),
        contracts: new Array<Contract>(),
        configuracioLoaded: false,
        configuracio: {
            horaInicial: null,
            horaFinal: null,
        } as ConfiguracioState,
    },
    mutations: {
        setLocale(state, newLocale) {
            state.locale = newLocale;
            localStorage.setItem('locale', newLocale);
        },
        setContracts(state, contracts) {
            state.contracts = contracts;
        },
        loading(state, isLoading) {
            if (isLoading) {
                state.loadingCount++;
                state.isLoading = true;
            } else if (state.loadingCount > 0) {
                state.loadingCount--;
                state.isLoading = (state.loadingCount > 0);
            }
        },
        clearContracts(state) {
            state.contracts = new Array<Contract>();
        },
        setConfiguracio(state, configuracio: ConfiguracioState) {
            state.configuracio = configuracio;
        },
        setConfiguracioLoaded(state, loaded: boolean) {
            state.configuracioLoaded = loaded;
        }
    },
    actions: {
        changeLocale({ commit }, newLocale) {
            commit('setLocale', newLocale);
        },
        clearContracts({ commit }) {
            commit('clearContracts');
        },
        async loadConfiguracio({ state, commit }) {
            if (state.configuracioLoaded) {
                return state.configuracio;
            }

            const data = await ConfiguracioService.getConfiguracio();
            commit('setConfiguracio', {
                horaInicial: data?.ModCaravaning?.horaInicial ?? null,
                horaFinal: data?.ModCaravaning?.horaFinal ?? null,
            });
            commit('setConfiguracioLoaded', true);

            return state.configuracio;
        }
    },
    getters: {
        currentLocale: (state): string => state.locale,
        loadingState: (state): boolean => state.isLoading,
        getContracts: (state): Contract[] => state.contracts,
        getConfiguracio: (state): ConfiguracioState => state.configuracio,
        getHoraInicial: (state): string | null => state.configuracio.horaInicial,
        getHoraFinal: (state): string | null => state.configuracio.horaFinal,
    },
});

export default store;

